(function () {
  'use strict';

  if (window.WAI_TEILEFINDER_APP) {
    window.WAI_TEILEFINDER_APP.initAll();
    return;
  }

  function normalize(value) {
    return String(value || '')
      .toLocaleLowerCase('de-DE')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/ß/g, 'ss')
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function compact(value) {
    return normalize(value).replace(/\s+/g, '');
  }

  function byGerman(a, b) {
    return a.localeCompare(b, 'de', { sensitivity: 'base', numeric: true });
  }

  function brandLabel(value) {
    var labels = {
      'Bmw': 'BMW',
      'Daf': 'DAF',
      'Ford Usa': 'Ford USA'
    };
    return labels[value] || value;
  }

  function option(parent, value, label) {
    var element = document.createElement('option');
    element.value = value;
    element.textContent = label || value;
    parent.appendChild(element);
    return element;
  }

  function clearSelect(select, placeholder) {
    select.innerHTML = '';
    option(select, '', placeholder);
  }

  function uniqueHandles(handles) {
    var unique = [];
    var seen = Object.create(null);
    (handles || []).forEach(function (handle) {
      if (handle && !seen[handle]) {
        seen[handle] = true;
        unique.push(handle);
      }
    });
    return unique;
  }

  function currentYear() {
    return new Date().getFullYear();
  }

  function yearOf(monthKey, openEndYear) {
    if (!monthKey) return openEndYear || currentYear();
    return Math.floor(Number(monthKey) / 100);
  }

  function formatMonth(monthKey, openLabel) {
    if (!monthKey) return openLabel || 'heute';
    var value = Number(monthKey);
    var month = String(value % 100).padStart(2, '0');
    var year = Math.floor(value / 100);
    return month + '.' + year;
  }

  function formatPeriod(startKey, endKey) {
    return formatMonth(startKey) + '–' + formatMonth(endKey, 'heute');
  }

  function fuelLabel(value) {
    var labels = {
      'Accumulator/Electric': 'Elektro',
      'Bio (ethanol) petrol or Methanol': 'Bioethanol/Methanol',
      'CNG (with or without Petrol)': 'Benzin/Erdgas (CNG)',
      'Diesel': 'Diesel',
      'Ethanol (with or without Diesel)': 'Diesel/Ethanol',
      'Full Hybrid/diesel': 'Vollhybrid/Diesel',
      'Gas (CNG)': 'Erdgas (CNG)',
      'LNG': 'Erdgas (LNG)',
      'LPG (with or without Petrol)': 'Benzin/Autogas (LPG)',
      'Mild Hybrid/diesel': 'Mild-Hybrid/Diesel',
      'Mild Hybrid/petrol': 'Mild-Hybrid/Benzin',
      'Nicht angegeben': 'Nicht angegeben',
      'Petrol': 'Benzin',
      'Plug-in Hybrid/diesel': 'Plug-in-Hybrid/Diesel'
    };
    return labels[value] || value || 'Nicht angegeben';
  }

  function formatDecimal(value, digits) {
    var number = Number(value);
    if (!Number.isFinite(number)) return '';
    return number.toLocaleString('de-DE', {
      minimumFractionDigits: digits,
      maximumFractionDigits: digits
    });
  }

  function modelLabel(modelRecord) {
    return modelRecord[0] + ' (' + formatPeriod(modelRecord[1], modelRecord[2]) + ')';
  }

  function recordMatchesYear(record, selectedYear) {
    if (String(selectedYear) === '*') return true;
    var year = Number(selectedYear);
    return year >= yearOf(record[4]) && year <= yearOf(record[5], currentYear());
  }

  function getYears(records) {
    var years = Object.create(null);
    records.forEach(function (record) {
      var startYear = yearOf(record[4]);
      var endYear = yearOf(record[5], currentYear());
      for (var year = startYear; year <= endYear; year += 1) years[year] = true;
    });
    return Object.keys(years).map(Number).sort(function (a, b) { return b - a; });
  }

  function getHandlesForYear(data, records, selectedYear) {
    return uniqueHandles(records.filter(function (record) {
      return recordMatchesYear(record, selectedYear);
    }).map(function (record) {
      return (data.handles || [])[Number(record[6])];
    }));
  }

  function engineIdentity(record) {
    return JSON.stringify([record[0], record[1], record[2], record[3]]);
  }

  function getEngines(data, records, selectedYear) {
    var grouped = Object.create(null);
    records.filter(function (record) {
      return recordMatchesYear(record, selectedYear);
    }).forEach(function (record) {
      var identity = engineIdentity(record);
      if (!grouped[identity]) {
        grouped[identity] = {
          key: identity,
          fuel: fuelLabel((data.fuels || [])[Number(record[0])]),
          vehicleCode: record[1] || '',
          capacity: record[2] || '',
          kw: record[3] || '',
          start: record[4],
          end: record[5],
          handles: []
        };
      } else {
        grouped[identity].start = Math.min(grouped[identity].start, record[4]);
        grouped[identity].end = (!grouped[identity].end || !record[5])
          ? 0
          : Math.max(grouped[identity].end, record[5]);
      }
      grouped[identity].handles.push((data.handles || [])[Number(record[6])]);
    });

    return Object.keys(grouped).map(function (identity) {
      var engine = grouped[identity];
      engine.handles = uniqueHandles(engine.handles);
      return engine;
    }).sort(function (a, b) {
      return byGerman(a.fuel, b.fuel) ||
        (Number(a.capacity) || 999) - (Number(b.capacity) || 999) ||
        (Number(a.kw) || 9999) - (Number(b.kw) || 9999) ||
        byGerman(a.vehicleCode, b.vehicleCode);
    });
  }

  function engineLabel(engine) {
    var parts = [];
    if (engine.capacity) parts.push(formatDecimal(engine.capacity, 1) + ' l');
    if (engine.kw) {
      var kw = Number(engine.kw);
      var ps = Number.isFinite(kw) ? Math.round(kw * 1.35962) : null;
      parts.push(formatDecimal(engine.kw, Number.isInteger(kw) ? 0 : 1) + ' kW' + (ps ? ' / ' + ps + ' PS' : ''));
    }
    if (engine.vehicleCode) parts.push('Typ ' + engine.vehicleCode);
    parts.push(formatPeriod(engine.start, engine.end));
    return parts.join(' · ');
  }

  function setTopProductsHidden(root, hidden) {
    var topProducts = root._tfTopProductsSection;
    if (!topProducts || !document.documentElement.contains(topProducts)) {
      var owner = root.closest('.shopify-section');
      var candidate = owner ? owner.nextElementSibling : null;
      for (var index = 0; candidate && index < 4; index += 1, candidate = candidate.nextElementSibling) {
        var headings = candidate.querySelectorAll('h1, h2, h3');
        var isTopProducts = Array.prototype.some.call(headings, function (heading) {
          return normalize(heading.textContent) === 'top produkte';
        });
        if (isTopProducts) {
          topProducts = candidate;
          root._tfTopProductsSection = candidate;
          break;
        }
      }
    }
    if (!topProducts) return;
    if (hidden) {
      topProducts.setAttribute('data-tf-hidden-by-finder', '1');
      topProducts.hidden = true;
    } else if (topProducts.getAttribute('data-tf-hidden-by-finder') === '1') {
      topProducts.hidden = false;
      topProducts.removeAttribute('data-tf-hidden-by-finder');
    }
  }

  function hideResults(root) {
    var result = root.querySelector('[data-tf-results]');
    var resultTitle = root.querySelector('[data-tf-results-title]');
    var resultInfo = root.querySelector('[data-tf-results-info]');
    var resultNote = root.querySelector('[data-tf-results-note]');
    var grid = root.querySelector('[data-tf-results-grid]');
    if (root._tfProductObserver) root._tfProductObserver.disconnect();
    result.hidden = true;
    resultTitle.textContent = 'Passende Artikel';
    resultInfo.textContent = '';
    if (resultNote) {
      resultNote.textContent = '';
      resultNote.hidden = true;
    }
    grid.innerHTML = '';
    setTopProductsHidden(root, false);
  }

  function createChip(text) {
    var chip = document.createElement('span');
    chip.className = 'tf-chip';
    chip.textContent = text;
    return chip;
  }

  function specLabel(name, value) {
    var labels = {
      'Stromspannung (V)': 'Spannung',
      'Stromstärke (A)': 'Stromstärke',
      'Leistung (kW)': 'Leistung',
      'Zähne': 'Zähne',
      'Drehrichtung (CW/CCW)': 'Drehrichtung',
      'B+ Anschluss': 'B+ Anschluss',
      'Riemenscheibe (mm)': 'Riemenscheibe',
      'Rillen': 'Rillen',
      'Anzahl Montagelöcher': 'Montagelöcher',
      'Einpass (mm)': 'Einpass'
    };
    var units = {
      'Stromspannung (V)': ' V',
      'Stromstärke (A)': ' A',
      'Leistung (kW)': ' kW',
      'Riemenscheibe (mm)': ' mm',
      'Einpass (mm)': ' mm'
    };
    var numericDigits = {
      'Stromspannung (V)': 0,
      'Stromstärke (A)': 0,
      'Leistung (kW)': 1,
      'Riemenscheibe (mm)': 1,
      'Einpass (mm)': 1,
      'Zähne': 0,
      'Anzahl Montagelöcher': 0
    };
    var displayValue = value;
    if (Object.prototype.hasOwnProperty.call(numericDigits, name) && Number.isFinite(Number(value))) {
      var number = Number(value);
      var digits = Number.isInteger(number) ? 0 : numericDigits[name];
      displayValue = formatDecimal(number, digits);
    }
    return (labels[name] || name) + ': ' + displayValue + (units[name] || '');
  }

  function importantSpecs(product) {
    var preferred = product.k === 'Lichtmaschine'
      ? ['Stromspannung (V)', 'Stromstärke (A)', 'Riemenscheibe (mm)', 'Rillen']
      : ['Stromspannung (V)', 'Leistung (kW)', 'Zähne', 'Drehrichtung (CW/CCW)'];
    var specs = Array.isArray(product.x) ? product.x : [];
    var selected = [];
    preferred.forEach(function (name) {
      var match = specs.find(function (pair) { return pair[0] === name; });
      if (match) selected.push(match);
    });
    specs.forEach(function (pair) {
      if (selected.length >= 4) return;
      if (!selected.some(function (item) { return item[0] === pair[0]; })) selected.push(pair);
    });
    return selected.slice(0, 4);
  }

  function storeProductUrl(routesRoot, handle, json) {
    return routesRoot.replace(/\/$/, '') + '/products/' + encodeURIComponent(handle) + (json ? '.js' : '');
  }

  function formatMoney(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    return new Intl.NumberFormat('de-DE', { style: 'currency', currency: currency }).format(Number(cents || 0) / 100);
  }

  var liveProductCache = Object.create(null);

  function getLiveProduct(routesRoot, handle) {
    if (!liveProductCache[handle]) {
      liveProductCache[handle] = fetch(storeProductUrl(routesRoot, handle, true), {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      }).then(function (response) {
        if (!response.ok) throw new Error('Produktdaten konnten nicht geladen werden.');
        return response.json();
      });
    }
    return liveProductCache[handle];
  }

  function hydrateProductCard(card, routesRoot, handle) {
    getLiveProduct(routesRoot, handle).then(function (liveProduct) {
      if (!card.isConnected) return;
      var media = card.querySelector('[data-tf-product-media]');
      var price = card.querySelector('[data-tf-product-price]');
      var stock = card.querySelector('[data-tf-product-stock]');
      var imageUrl = liveProduct.featured_image || (liveProduct.images || [])[0];

      if (media && imageUrl) {
        media.innerHTML = '';
        var image = document.createElement('img');
        image.src = String(imageUrl).indexOf('//') === 0 ? 'https:' + imageUrl : imageUrl;
        image.alt = liveProduct.title || '';
        image.loading = 'lazy';
        media.appendChild(image);
      }
      if (price) {
        price.classList.remove('is-loading');
        price.textContent = formatMoney(liveProduct.price);
      }
      if (stock) {
        stock.textContent = liveProduct.available ? 'Versand in 3–5 Werktagen' : 'Derzeit nicht verfügbar';
        stock.classList.toggle('is-unavailable', !liveProduct.available);
        stock.hidden = false;
      }
    }).catch(function () {
      var price = card.querySelector('[data-tf-product-price]');
      if (price) price.hidden = true;
    });
  }

  function renderProducts(root, handles, title, contextText, options) {
    var data = window.WAI_TEILEFINDER_DATA;
    var result = root.querySelector('[data-tf-results]');
    var resultTitle = root.querySelector('[data-tf-results-title]');
    var resultInfo = root.querySelector('[data-tf-results-info]');
    var resultNote = root.querySelector('[data-tf-results-note]');
    var resultReset = root.querySelector('[data-tf-reset-results]');
    var grid = root.querySelector('[data-tf-results-grid]');
    var routesRoot = root.getAttribute('data-routes-root') || '/';
    var settings = options || {};

    var unique = uniqueHandles(handles).filter(function (handle) {
      return data.products[handle];
    });

    result.hidden = false;
    resultTitle.textContent = title;
    resultInfo.textContent = contextText || (unique.length + (unique.length === 1 ? ' passender Artikel' : ' passende Artikel'));
    if (resultNote) {
      resultNote.textContent = settings.note || '';
      resultNote.hidden = !settings.note;
    }
    if (resultReset) resultReset.hidden = !settings.showReset;
    grid.innerHTML = '';
    setTopProductsHidden(root, true);
    if (root._tfProductObserver) root._tfProductObserver.disconnect();

    var observer = typeof IntersectionObserver === 'function'
      ? new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            observer.unobserve(entry.target);
            hydrateProductCard(entry.target, routesRoot, entry.target.getAttribute('data-tf-product-handle'));
          });
        }, { rootMargin: '350px' })
      : null;
    root._tfProductObserver = observer;

    if (!unique.length) {
      var empty = document.createElement('div');
      empty.className = 'tf-empty';
      empty.textContent = 'Für diese Auswahl wurde kein passender Artikel gefunden.';
      grid.appendChild(empty);
      result.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }

    unique.forEach(function (handle) {
      var product = data.products[handle];
      var card = document.createElement('article');
      card.className = 'tf-product-card';
      card.setAttribute('data-tf-product-handle', handle);

      var media = document.createElement('a');
      media.className = 'tf-product-media';
      media.href = storeProductUrl(routesRoot, handle, false);
      media.setAttribute('data-tf-product-media', '');
      media.setAttribute('aria-label', product.t);
      var placeholder = document.createElement('span');
      placeholder.className = 'tf-product-placeholder';
      placeholder.textContent = 'Produktbild wird geladen';
      media.appendChild(placeholder);
      card.appendChild(media);

      if (settings.matchLabel) {
        var matchBadge = document.createElement('div');
        matchBadge.className = 'tf-match-badge';
        matchBadge.textContent = settings.matchLabel;
        card.appendChild(matchBadge);
      }

      var type = document.createElement('div');
      type.className = 'tf-product-type';
      type.textContent = product.k || '';
      card.appendChild(type);

      var heading = document.createElement('h3');
      heading.className = 'tf-product-title';
      var titleLink = document.createElement('a');
      titleLink.href = storeProductUrl(routesRoot, handle, false);
      titleLink.textContent = product.t;
      heading.appendChild(titleLink);
      card.appendChild(heading);

      var sku = document.createElement('div');
      sku.className = 'tf-sku';
      sku.textContent = 'Artikel-Nr.: ' + product.s;
      card.appendChild(sku);

      var price = document.createElement('div');
      price.className = 'tf-price is-loading';
      price.setAttribute('data-tf-product-price', '');
      price.textContent = 'Preis wird geladen …';
      card.appendChild(price);

      var stock = document.createElement('div');
      stock.className = 'tf-stock';
      stock.setAttribute('data-tf-product-stock', '');
      stock.hidden = true;
      card.appendChild(stock);

      if (Array.isArray(product.x) && product.x.length) {
        var chips = document.createElement('div');
        chips.className = 'tf-chips';
        importantSpecs(product).forEach(function (pair) {
          chips.appendChild(createChip(specLabel(pair[0], pair[1])));
        });
        card.appendChild(chips);
      }

      var cta = document.createElement('a');
      cta.className = 'tf-product-link';
      cta.href = storeProductUrl(routesRoot, handle, false);
      cta.textContent = 'Details & OE-Nummern prüfen';
      card.appendChild(cta);
      grid.appendChild(card);
      if (observer) observer.observe(card);
      else hydrateProductCard(card, routesRoot, handle);
    });

    result.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function init(root) {
    if (!root || root.getAttribute('data-tf-ready') === '1') return;
    var data = window.WAI_TEILEFINDER_DATA;
    if (!data || data.version !== 4 || !data.fitments || !data.products) {
      setTimeout(function () { init(root); }, 100);
      return;
    }
    root.setAttribute('data-tf-ready', '1');

    var typeSelect = root.querySelector('[data-tf-type]');
    var brandSelect = root.querySelector('[data-tf-brand]');
    var modelSelect = root.querySelector('[data-tf-model]');
    var modelSearch = root.querySelector('[data-tf-model-search]');
    var yearSelect = root.querySelector('[data-tf-year]');
    var engineSelect = root.querySelector('[data-tf-engine]');
    var resetButton = root.querySelector('[data-tf-reset]');
    var resetResultsButton = root.querySelector('[data-tf-reset-results]');
    var vehicleHint = root.querySelector('[data-tf-vehicle-hint]');
    var searchForm = root.querySelector('[data-tf-search-form]');
    var searchInput = root.querySelector('[data-tf-search]');
    var searchHint = root.querySelector('[data-tf-search-hint]');
    var tabButtons = root.querySelectorAll('[data-tf-tab]');
    var tabPanels = root.querySelectorAll('[data-tf-panel]');
    var stageFields = root.querySelectorAll('[data-tf-stage]');

    if (!typeSelect || !brandSelect || !modelSelect || !modelSearch || !yearSelect || !engineSelect || !resetButton || !vehicleHint) return;

    var currentModel = null;
    var currentModels = [];
    var currentEngines = [];

    function setVisibleStage(maxStage) {
      Array.prototype.forEach.call(stageFields, function (field) {
        field.hidden = Number(field.getAttribute('data-tf-stage')) > maxStage;
      });
    }

    function activateTab(mode) {
      Array.prototype.forEach.call(tabButtons, function (button) {
        var active = button.getAttribute('data-tf-tab') === mode;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', active ? 'true' : 'false');
        button.tabIndex = active ? 0 : -1;
      });
      Array.prototype.forEach.call(tabPanels, function (panel) {
        panel.hidden = panel.getAttribute('data-tf-panel') !== mode;
      });
      if (mode === 'vehicle' && engineSelect.value && currentModel) {
        showVehicleResults();
      } else {
        hideResults(root);
      }
    }

    function updateResetButton() {
      var hidden = !(typeSelect.value || brandSelect.value || modelSelect.value || yearSelect.value || engineSelect.value);
      resetButton.hidden = hidden;
      if (resetResultsButton) resetResultsButton.hidden = hidden;
    }

    function resetAfter(selectName) {
      if (selectName === 'type') {
        clearSelect(brandSelect, 'Zuerst Teileart wählen');
        brandSelect.disabled = true;
      }
      if (selectName === 'type' || selectName === 'brand') {
        clearSelect(modelSelect, 'Zuerst Hersteller wählen');
        modelSelect.disabled = true;
        modelSearch.value = '';
        modelSearch.disabled = true;
        currentModel = null;
        currentModels = [];
      }
      if (selectName === 'model') currentModel = null;
      if (selectName !== 'year' && selectName !== 'engine') {
        clearSelect(yearSelect, 'Zuerst Modell wählen');
        yearSelect.disabled = true;
      }
      if (selectName !== 'engine') {
        clearSelect(engineSelect, 'Zuerst Baujahr wählen');
        engineSelect.disabled = true;
        currentEngines = [];
      }
      vehicleHint.textContent = '';
      hideResults(root);
    }

    function resetVehicleFinder() {
      typeSelect.value = '';
      resetAfter('type');
      setVisibleStage(1);
      updateResetButton();
      typeSelect.focus();
    }

    function populateEngines() {
      clearSelect(engineSelect, yearSelect.value ? 'Motorisierung wählen' : 'Zuerst Baujahr wählen');
      engineSelect.disabled = !yearSelect.value;
      currentEngines = [];
      vehicleHint.textContent = '';
      hideResults(root);
      if (!yearSelect.value || !currentModel) return;

      currentEngines = getEngines(data, currentModel[3], yearSelect.value);
      var groups = Object.create(null);
      currentEngines.forEach(function (engine) {
        if (!groups[engine.fuel]) groups[engine.fuel] = [];
        groups[engine.fuel].push(engine);
      });

      Object.keys(groups).sort(byGerman).forEach(function (fuel) {
        var optgroup = document.createElement('optgroup');
        optgroup.label = fuel.toUpperCase();
        groups[fuel].forEach(function (engine) {
          option(optgroup, engine.key, engine.fuel + ' · ' + engineLabel(engine));
        });
        engineSelect.appendChild(optgroup);
      });
      option(engineSelect, '*', 'Motorisierung nicht bekannt – alle anzeigen');
      engineSelect.disabled = false;

      if (currentEngines.length > 1) {
        vehicleHint.textContent = 'Wählen Sie die Motorisierung anhand von Kraftstoff, Hubraum, Leistung und Fahrzeugcode.';
      }
    }

    function populateModels(query) {
      clearSelect(modelSelect, 'Modell wählen');
      var normalizedQuery = normalize(query);
      var matches = currentModels.map(function (modelRecord, index) {
        return { record: modelRecord, index: index, label: modelLabel(modelRecord) };
      }).filter(function (item) {
        return !normalizedQuery || normalize(item.label).indexOf(normalizedQuery) !== -1;
      });
      var visibleLimit = 250;
      matches.slice(0, visibleLimit).forEach(function (item) {
        option(modelSelect, String(item.index), item.label);
      });
      modelSelect.disabled = !brandSelect.value || !matches.length;
      if (!matches.length) {
        vehicleHint.textContent = 'Kein Modell für diese Eingabe gefunden.';
      } else if (matches.length > visibleLimit) {
        vehicleHint.textContent = matches.length + ' Modelle gefunden. Bitte grenzen Sie die Suche weiter ein.';
      } else if (currentModels.length > visibleLimit && !normalizedQuery) {
        vehicleHint.textContent = currentModels.length + ' Modelle verfügbar. Nutzen Sie das Suchfeld, um die Liste einzugrenzen.';
      } else {
        vehicleHint.textContent = '';
      }
    }

    clearSelect(typeSelect, 'Teileart wählen');
    Object.keys(data.fitments).sort(byGerman).forEach(function (type) { option(typeSelect, type); });
    resetAfter('type');
    setVisibleStage(1);
    activateTab('vehicle');
    updateResetButton();

    Array.prototype.forEach.call(tabButtons, function (button) {
      button.addEventListener('click', function () {
        var mode = button.getAttribute('data-tf-tab');
        activateTab(mode);
        if (mode === 'search') searchInput.focus();
        else if (!typeSelect.value) typeSelect.focus();
      });
    });

    typeSelect.addEventListener('change', function () {
      resetAfter('type');
      brandSelect.disabled = !typeSelect.value;
      setVisibleStage(typeSelect.value ? 2 : 1);
      updateResetButton();
      if (!typeSelect.value) return;
      clearSelect(brandSelect, 'Hersteller wählen');
      Object.keys(data.fitments[typeSelect.value] || {}).sort(byGerman).forEach(function (brand) {
        option(brandSelect, brand, brandLabel(brand));
      });
    });

    brandSelect.addEventListener('change', function () {
      resetAfter('brand');
      modelSelect.disabled = !brandSelect.value;
      setVisibleStage(brandSelect.value ? 3 : 2);
      updateResetButton();
      if (!brandSelect.value) return;
      currentModels = (data.fitments[typeSelect.value] || {})[brandSelect.value] || [];
      modelSearch.disabled = false;
      populateModels('');
    });

    modelSearch.addEventListener('input', function () {
      resetAfter('model');
      setVisibleStage(3);
      populateModels(modelSearch.value);
      updateResetButton();
    });

    modelSelect.addEventListener('change', function () {
      resetAfter('model');
      setVisibleStage(modelSelect.value === '' ? 3 : 4);
      updateResetButton();
      if (modelSelect.value === '') return;
      currentModel = currentModels[Number(modelSelect.value)];
      if (!currentModel) return;
      modelSearch.value = currentModel[0];

      clearSelect(yearSelect, 'Baujahr wählen');
      var years = getYears(currentModel[3]);
      years.forEach(function (year) { option(yearSelect, String(year)); });
      option(yearSelect, '*', 'Baujahr nicht bekannt – alle anzeigen');
      yearSelect.disabled = false;
    });

    yearSelect.addEventListener('change', function () {
      resetAfter('year');
      setVisibleStage(yearSelect.value ? 5 : 4);
      populateEngines();
      updateResetButton();
    });

    function showVehicleResults() {
      hideResults(root);
      updateResetButton();
      if (!engineSelect.value || !currentModel) return;

      var allHandles = getHandlesForYear(data, currentModel[3], yearSelect.value);
      var withoutEngineFilter = engineSelect.value === '*';
      var selectedEngine = currentEngines.find(function (engine) {
        return engine.key === engineSelect.value;
      });
      var handles = withoutEngineFilter ? allHandles : (selectedEngine ? selectedEngine.handles : []);
      var yearText = yearSelect.value === '*' ? 'ohne Baujahrfilter' : 'Baujahr ' + yearSelect.value;
      var engineText = withoutEngineFilter ? 'ohne Motorfilter' : (selectedEngine ? selectedEngine.fuel + ' · ' + engineLabel(selectedEngine) : 'Motorisierung');
      var displayBrand = brandLabel(brandSelect.value);
      var matchParts = [displayBrand, currentModel[0]];
      if (yearSelect.value !== '*') matchParts.push('Baujahr ' + yearSelect.value);
      if (!withoutEngineFilter && selectedEngine) {
        var shortEngine = selectedEngine.fuel || '';
        if (selectedEngine.capacity) {
          shortEngine += (shortEngine ? ' ' : '') + formatDecimal(selectedEngine.capacity, 1) + ' l';
        }
        if (shortEngine) matchParts.push(shortEngine);
      }
      renderProducts(
        root,
        handles,
        'Passende Artikel',
        handles.length + (handles.length === 1 ? ' Treffer' : ' Treffer') + ' für ' +
          typeSelect.value + ' · ' + displayBrand + ' · ' + currentModel[0] + ' · ' + yearText + ' · ' + engineText,
        {
          matchLabel: 'Passend zu Ihrer Auswahl: ' + matchParts.join(' · '),
          note: 'Die Fahrzeugzuordnung grenzt die Auswahl ein. Bitte vergleichen Sie zusätzlich die OE-Nummer, Anschlüsse und technische Ausführung mit dem ausgebauten Teil.',
          showReset: true
        }
      );
    }

    engineSelect.addEventListener('change', showVehicleResults);

    resetButton.addEventListener('click', resetVehicleFinder);
    if (resetResultsButton) resetResultsButton.addEventListener('click', resetVehicleFinder);

    searchForm.addEventListener('submit', function (event) {
      event.preventDefault();
      var raw = searchInput.value.trim();
      var query = normalize(raw);
      if (query.length < 2) {
        searchHint.textContent = 'Bitte mindestens 2 Zeichen eingeben.';
        return;
      }
      searchHint.textContent = '';
      var tokens = query.split(' ').filter(Boolean);
      var compactQuery = compact(raw);
      var scored = [];
      var exactSku = [];

      Object.keys(data.products).forEach(function (handle) {
        var product = data.products[handle];
        if (compact(product.s) === compactQuery) exactSku.push(handle);
      });

      if (exactSku.length) {
        exactSku.forEach(function (handle) { scored.push({ handle: handle, score: 2000 }); });
      } else {
        Object.keys(data.products).forEach(function (handle) {
          var product = data.products[handle];
          var haystack = product.q || '';
          var paddedHaystack = ' ' + haystack + ' ';
          var tokenMatch = tokens.every(function (token) {
            return paddedHaystack.indexOf(' ' + token + ' ') !== -1;
          });
          var compactMatch = compactQuery.length >= 5 && haystack.replace(/\s+/g, '').indexOf(compactQuery) !== -1;
          if (!tokenMatch && !compactMatch) return;

          var score = 0;
          var skuNormalized = normalize(product.s);
          var titleNormalized = normalize(product.t);
          if (titleNormalized.indexOf(query) !== -1) score += 200;
          if (compactMatch) score += 150;
          tokens.forEach(function (token) {
            if (skuNormalized.indexOf(token) !== -1) score += 25;
            if (titleNormalized.indexOf(token) !== -1) score += 10;
          });
          scored.push({ handle: handle, score: score });
        });
      }

      scored.sort(function (a, b) {
        if (b.score !== a.score) return b.score - a.score;
        return data.products[a.handle].t.localeCompare(data.products[b.handle].t, 'de');
      });

      var total = scored.length;
      var visible = scored.slice(0, 40).map(function (item) { return item.handle; });
      var info = total ? (total + (total === 1 ? ' Treffer' : ' Treffer') + (total > 40 ? ' · die besten 40 werden angezeigt' : '')) : 'Keine Treffer';
      renderProducts(root, visible, 'Merkmalsuche', info + ' für „' + raw + '“', {
        note: 'Bitte öffnen Sie den Artikel und prüfen Sie vor der Bestellung die OE-Nummer und technische Ausführung.',
        showReset: false
      });
    });
  }

  function initAll(scope) {
    var context = scope || document;
    var roots = context.querySelectorAll('[data-teilefinder]');
    for (var index = 0; index < roots.length; index += 1) init(roots[index]);
  }

  window.WAI_TEILEFINDER_APP = {
    initAll: initAll,
    getYears: getYears,
    getEngines: getEngines,
    getHandlesForYear: getHandlesForYear,
    modelLabel: modelLabel,
    engineLabel: engineLabel
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
}());
